module.exports = __webpack_public_path__ + "static/media/ePoint_color.87ddbd18.png";